import { v1 as uuid } from 'uuid'
// module imports
import notifySystemIncoming from 'modules/Notifications'
// constant imports
import * as C from './constants'

export const createLocalNotification = (notification) => ({
  type: C.LOCAL_CREATE,
  payload: { ...notification, date: new Date(), id: uuid() },
})

export const removeLocalNotification = (index) => ({
  type: C.LOCAL_REMOVE,
  payload: index,
})

export const createSystemNotification = (id) => ({
  type: C.SYSTEM_CREATE,
  payload: notifySystemIncoming(id),
})

export const removeSystemNotification = (index) => ({
  type: C.SYSTEM_REMOVE,
  payload: index || 0,
})
